<template>
	<div style="margin-top: 20px;">
		<a-form :form="form" layout="horizontal" style="width: 60%;padding-bottom: 20px;">
			<!-- <a-form-item label="奖励平台类型" v-bind="formItemLayout">
				<a-radio-group v-decorator="['awardPlatformType', { rules: [{ required: true, message: '奖励平台类型必须选择!' }] }]">
					<a-radio v-for="item in awardPlatformTypeArr" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
				</a-radio-group>
			</a-form-item> -->
			<a-form-item label="是否重点领域账号" v-if="platformType2 == 'redbook' && (awardRule.id == 3 || awardRule.id == 4) " v-bind="formItemLayout">
				<a-radio-group v-decorator="['whetherKeyAreaAccount', { initialValue: '0', rules: [{ required: true, message: '请选择是否重点领域账号' }] }]">
					<a-radio-button value="1">是</a-radio-button>
					<a-radio-button value="0">否</a-radio-button>
				</a-radio-group>
			</a-form-item>
			<a-form-item label="本月更频达15条" v-if="platformType2 == 'douyin' && awardType == 'a_dy_a_dianzhan'  && (awardRule.id == 6 ) " v-bind="formItemLayout">
				<a-radio-group v-decorator="['whetherReachNumber', { initialValue: '0', rules: [{ required: true, message: '请选择是否本月更频达15条' }] }]">
					<a-radio-button value="1">是</a-radio-button>
					<a-radio-button value="0">否</a-radio-button>
				</a-radio-group>
			</a-form-item>
			<a-form-item label="奖励类型" v-bind="formItemLayout">
				<a-select @change="awardTypeChange" v-decorator="['awardType', { rules: [{ required: true, message: '请选择奖励类型' }] }]" placeholder="请选择奖励类型">
					<a-select-option v-for="item in awardTypeList" :key="item.key">{{ item.value }}</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item label="内容类型" v-if="showContentType" v-bind="formItemLayout">
				<a-select
					@change="contentTypeChange"
					v-decorator="['contentType', { rules: [{ required: requiredContentType, message: '请选择内容类型' }] }]"
					placeholder="请选择内容类型"
					allowClear
				>
					<a-select-option v-for="item in contentTypeList" :key="item.key">{{ item.value }}</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item
				label="粉丝层级"
				v-if="(platformType2 == 'bilibili' || platformType2 == 'redbook' || platformType2 == 'channels' || platformType2 == 'douyin') && showFansLevel"
				v-bind="formItemLayout"
			>
				<a-select
					@change="fansLevelChange"
					v-decorator="['fansLevel', { rules: [{ required: requiredFansLevel, message: '请选择粉丝层级' }] }]"
					placeholder="请选择粉丝层级"
					allowClear
				>
					<a-select-option v-for="item in fansLevelList" :key="item.key">{{ item.value }}</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item label="奖励级别" v-bind="formItemLayout">
				<a-select @change="dataDemandChange" v-decorator="['dataDemand', { rules: [{ required: true, message: '请选择奖励级别' }] }]" placeholder="请选择奖励级别">
					<a-select-option v-for="item in dataDemandList" :key="item.key">{{ item.value }}</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item label="热搜话题" v-if="awardType == 'a_wb_a_reshou' || awardType == 'a_dy_a_rebang' || awardType == 'a_bz_a_reshou'  " v-bind="formItemLayout">
				<a-input v-decorator="['hotTopic', { rules: [{ required: true, message: '请录热搜话题' }] }]" placeholder="请录入热搜话题" />
			</a-form-item>
			<!-- <a-form-item label="自定义提成金额" v-if="customState" v-bind="formItemLayout">
				<a-input-number
					style="width: 100%;"
					placeholder="请录入自定义提成金额"
					v-decorator="['customAmount', { rules: [{ required: true, message: '请录入自定义提成金额' }] }]"
					:min="1"
					:max="9999999999"
				/>
			</a-form-item> -->
			<!-- <a-form-item label="是否为新账号" v-if="platformType2 == 'weibo'" v-bind="formItemLayout">
				<a-radio-group v-decorator="['whetherNewAccount', { initialValue: '0', rules: [{ required: true, message: '请选择是否为新账号' }] }]">
					<a-radio-button value="1">是</a-radio-button>
					<a-radio-button value="0">否</a-radio-button>
				</a-radio-group>
			</a-form-item> -->

			<a-form-item
				label="万转条数(第几条)"
				v-if="platformType2 == 'weibo' && awardType == 'a_wb_a_wanzhuan' && contentType == 'a_wb_yuanchuangshipin'"
				v-bind="formItemLayout"
			>
				<a-input-number
					style="width: 100%;"
					placeholder="请录入万转条数(第几条)"
					v-decorator="['wanzhuanNum', { rules: [{ required: true, message: '请录入万转条数' }] }]"
					:min="1"
					:max="100"
				/>
			</a-form-item>
			<a-form-item label="真实数据" v-bind="formItemLayout">
				<a-input-number
					style="width: 100%;"
					placeholder="请录入真实数据"
					:precision="0"
					v-decorator="['realNum', { rules: [{ required: true, message: '请录入真实数据' }] }]"
					:min="1"
					:max="9999999999"
				/>
			</a-form-item>
			<a-form-item label="内容链接" v-if="platformType2 != 'channels'" v-bind="formItemLayout">
				<a-input v-decorator="['contentUrl', { rules: [{ required: true, message: '请录内容链接' }] }]" placeholder="请录入内容链接" />
			</a-form-item>
			<a-form-item label="参与人员" v-bind="formItemLayout">
				<div class="group" v-for="(item, index) in dataList">
					<a-select showSearch @search="searchUser" optionFilterProp="children" placeholder="参与人" style="width: 28%" v-model="item.userId">
						<a-select-option v-for="(item, index) in userList" :value="item.userId" :key="item.userId">{{ item.realname }}</a-select-option>
					</a-select>
					<a-select optionFilterProp="children" v-model="item.position" placeholder="职务" style="margin-left: 5px;width: 28%;">
						<a-select-option v-for="item in awardPostArr" :key="item.key">{{ item.value }}</a-select-option>
					</a-select>
					<a-input-number :min="0" :max="100" v-model="item.percent" placeholder="奖金比例" style="margin-left: 5px;width: 28%;" />
					%
					<a-icon type="close-circle" style="color: red;" @click="del(index)" />
				</div>
				<a-button type="dashed" block @click="add">增加参与人员</a-button>
			</a-form-item>
			<a-form-item label="附件" v-bind="formItemLayout"><UploadFile :params="fileParams" :defaultFileList="fileArr"></UploadFile></a-form-item>
			<a-form-item label="备注" v-bind="formItemLayout"><a-input type="textarea" v-decorator="['remark']" placeholder="请录入备注" /></a-form-item>
			<a-form-item style="text-align: center;padding-top: 20px;">
				<a-button style="width: 100%;" type="primary" @click="handleSubmit">保存并生成奖励金额</a-button>
			</a-form-item>
		</a-form>
	</div>
</template>

<script>
import moment from 'moment';
import UploadFile from '@/views/common/UploadFile';
import { classify, folder } from '@/utils/fileSetting';

let timeout;
let currentValue;

const formItemLayout = {
	labelCol: {
		span: 6
	},
	wrapperCol: {
		span: 18
	}
};

export default {
	components: {
		UploadFile
	},
	props: {
		awardItem: {
			type: Object,
			default: null
		},
		canEdit: {
			type: Boolean,
			default: false
		},
		platformType: {
			type: String,
			required: true
		}
	},
	watch: {
		awardItem: {
			immediate: true,
			handler(newVal, oldVal) {
				this.id = newVal.id;
				if (this.id) {
					this.setFormValues(newVal);
				}
			}
		}
	},
	computed: {
		platformType2: {
			get: function() {
				if (this.platformType == 'kuaishou') {
					return 'douyin';
				}
				return this.platformType;
			}
		}
	},
	data() {
		return {
			formItemLayout,
			form: this.$form.createForm(this),
			id: null,
			awardRule: null,
			awardRuleId: null,
			customState: false,
			awardType: null,
			contentType: null,
			dataDemand: null,
			awardTypeArr: [],
			awardTypeList: [],
			contentTypeArr: [],
			contentTypeList: [],
			dataDemandArr: [],
			dataDemandList: [],
			dataList: [],
			awardPostArr: [],
			awardPostList: [],
			fansLevelArr: [],
			fansLevelList: [],
			awardPlatformTypeArr: [],
			awardTypeName: null,
			awardCustomConfig: [],
			userList: [],
			showContentType: true,
			requiredContentType: true,
			showFansLevel: true,
			requiredFansLevel: true,
			labelCol: {
				xs: { span: 24 },
				sm: { span: 5 }
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 13 }
			},
			fileParams: {
				folder: folder.award_file,
				classify: classify.award_file
			},
			fileArr: []
		};
	},
	mounted() {
		this.$get('awardRule/getAwardRule').then(res => {
			this.awardRule = res.data;
			// if (res.data != null && res.data.id) {
			// 	this.awardRuleId = res.data.id;
			// 	this.$get('awardRuleItem/getList', { awardRuleId: res.data.id, platformType: this.platformType2 }).then(res => {
			// 		this.awardRuleItemList = res.data;
			// 	});
			// }
		});
		this.$get('config/getValueByKey', { key: 'award_custom_config' }).then(res => {
			this.awardCustomConfig = JSON.parse(res.data.data);
		});
		// this.awardTypeName = `${this.platformType2}_award_type`;
		// this.$get(`dictionary-detail/listByAwardDictType/${this.platformType2}/award_type`, {}).then(res => {
		// 	this.awardTypeArr = res.data;
		// });
		// this.$get(`dictionary-detail/listByAwardDictType/${this.platformType2}/content_type`, {}).then(res => {
		// 	this.contentTypeArr = res.data;
		// });
		this.$get(`dictionary-detail/listByDictType/award_post`).then(res => {
			this.awardPostArr = res.data;
		});
		// this.$get(`dictionary-detail/listByAwardDictType/${this.platformType2}/fans_level`, {}).then(res => {
		// 	this.fansLevelArr = res.data;
		// });
		this.$get(`dictionary-detail/listByDictType/award_platform_type`).then(res => {
			this.awardPlatformTypeArr = res.data;
		});
	},
	methods: {
		setFormValues({ ...item }) {
			this.getBasicData(item);
			this.awardType = item.awardType;
			this.contentType = item.contentType;
			this.dataDemand = item.dataDemand;
			this.awardTypeName = `${this.platformType2}_award_type`;
			let fields = [
				'awardPlatformType',
				'awardType',
				'contentType',
				'dataDemand',
				'realNum',
				'wanzhuanNum',
				'contentUrl',
				'remark',
				'fansLevel',
				'customAmount',
				'whetherNewAccount',
				'whetherKeyAreaAccount'
			];
			Object.keys(item).forEach(key => {
				if (fields.indexOf(key) !== -1) {
					this.form.getFieldDecorator(key);
					let obj = {};
					obj[key] = item[key] || undefined;
					this.form.setFieldsValue(obj);
				}
			});
			if (item.awardType) {
				this.$get(`dictionary-detail/listByAwardDictType/${this.platformType2}/data_demand`, { awardType: item.awardType }).then(res => {
					this.dataDemandArr = res.data;
				});
			}
			this.userList = item.awardParticipantUserList;
			this.dataList = item.awardParticipantList;
			this.fileArr = item.fileList;
			this.customState = false;
			this.$get('config/getValueByKey', { key: 'award_custom_config' }).then(res => {
				this.awardCustomConfig = JSON.parse(res.data.data);
				this.awardCustomConfig.forEach(e => {
					if (e.platformType == this.platformType && e.awardType == this.awardType && e.contentType == this.contentType && e.dataDemand == this.dataDemand) {
						this.customState = true;
						this.form.getFieldDecorator('customAmount');
						this.form.setFieldsValue({ customAmount: item.customAmount });
					}
				});
			});
		},

		getBasicData(awardApplyItem) {
			let awardRuleItemList = [];
			let awardTypeRuleList = [];
			let result = Promise.all([
				this.$get('awardRule/getAwardRule'),
				this.$get('awardRuleItem/getList', { awardRuleId: null, platformType: this.platformType2 }),
				this.$get(`dictionary-detail/listByAwardDictType/${this.platformType2}/award_type`, {}),
				this.$get(`dictionary-detail/listByAwardDictType/${this.platformType2}/content_type`, {}),
				this.$get(`dictionary-detail/listByAwardDictType/${this.platformType2}/fans_level`, {})
			]);
			result
				.then(data => {
					this.awardRule = data[0].data;
					this.awardRuleItemList = data[1].data;
					awardRuleItemList = data[1].data;
					this.awardTypeArr = data[2].data;
					this.contentTypeArr = data[3].data;
					this.fansLevelArr = data[4].data;
				})
				.then(res => {
					if (awardRuleItemList != null && awardRuleItemList.length > 0) {
						awardTypeRuleList = [
							...new Set(
								awardRuleItemList.map((item, index) => {
									return item.awardType;
								})
							)
						];
						this.awardTypeList = this.awardTypeArr.filter(item => {
							return awardTypeRuleList.includes(item.key)
						});
						if (awardApplyItem.awardType) {
							//获取列表
							this.seachByAwardType(awardApplyItem.awardType)
								.then(res => {
									this.seachByContentType(awardApplyItem.contentType);
								})
								.then(res => {
									this.seachByFansLevel(awardApplyItem.fansLevel);
								});
						}
					}
				});
		},
		getAwardCustomConfig() {
			this.$get('config/getValueByKey', { key: 'award_custom_config' }).then(res => {
				this.awardCustomConfig = JSON.parse(res.data.data);
			});
		},
		add() {
			this.dataList.push({});
		},
		del(index) {
			this.dataList.splice(index, 1);
		},
		awardTypeChange(val) {
			this.awardType = val;
			this.form.resetFields('contentType');
			this.contentType = null;
			this.form.resetFields('fansLevel');
			this.fansLevel = null;
			this.form.resetFields('dataDemand');
			this.dataDemand = null;
			this.getCustomState();
			this.seachByAwardType(val);
		},
		seachByAwardType(val) {
			return new Promise((resolve, reject) => {
				this.$get(`dictionary-detail/listByAwardDictType/${this.platformType2}/data_demand`, { awardType: val })
					.then(res => {
						this.dataDemandArr = res.data;
					})
					.then(res => {
						if (val) {
							let awardRuleItemList = this.awardRuleItemList.filter(item => item.awardType == val);
							//判断该奖励类型对应的内容类型显影情况和必填情况
							let contentTypeRuleList = [];
							let showContentType = true;
							let requiredContentType = true;
							let existContentType = false;
							if (awardRuleItemList.length > 0) {
								awardRuleItemList.forEach(e => {
									if (e.contentType == null || e.contentType == '') {
										requiredContentType = false;
										showContentType = false;
									} else {
										existContentType = true;
										Array.prototype.push.apply(contentTypeRuleList,e.contentType.split(','));
									}
								});
								if (existContentType) {
									showContentType = true;
								}
							}
							contentTypeRuleList = [...new Set(contentTypeRuleList)];
							this.showContentType = showContentType;
							this.requiredContentType = requiredContentType;

							//有内容类型
							if (showContentType) {
								this.contentTypeList = this.contentTypeArr.filter(item => {
									if (contentTypeRuleList.includes(item.key)) {
										return item;
									}
								});
							}
							//当没有内容类型，或内容类型不必填，查下一级list
							if (!showContentType || !requiredContentType) {
								//判断有无粉丝
								let fansLevelRuleList = [];
								let showFansLevel = true;
								let requiredFansLevel = true;
								let existFansLevel = false;
								if (['bilibili', 'redbook', 'channels','douyin'].includes(this.platformType2)) {
									//有粉丝层级，先判断显影和是否必填
									if (awardRuleItemList.length > 0) {
										awardRuleItemList.forEach(e => {
											if (e.fansLevel == null || e.fansLevel == '') {
												requiredFansLevel = false;
												showFansLevel = false;
											} else {
												existFansLevel = true;
												Array.prototype.push.apply(fansLevelRuleList,e.fansLevel.split(','));
											}
										});
										if (existFansLevel) {
											showFansLevel = true;
										}
									}
									fansLevelRuleList = [...new Set(fansLevelRuleList)];
									this.showFansLevel = showFansLevel;
									this.requiredFansLevel = requiredFansLevel;
									//需要展示粉丝层级
									if (showFansLevel) {
										this.fansLevelList = this.fansLevelArr.filter(item => {
											if (fansLevelRuleList.includes(item.key)) {
												return item;
											}
										});
									}
								}
								//没有粉丝层级或粉丝层级不显示或粉丝层级不必填，直接查奖励级别
								if (!['bilibili', 'redbook', 'channels','douyin'].includes(this.platformType2) || !showFansLevel || !requiredFansLevel) {
									let dataDemandRuleList = [];
									if (awardRuleItemList.length > 0) {
										awardRuleItemList.forEach(e => {
											if (e.dataDemand != null && e.dataDemand != '') {
												Array.prototype.push.apply(dataDemandRuleList,e.dataDemand.split(','));
											}
										});
									}
									dataDemandRuleList = [... new Set(dataDemandRuleList)]

									this.dataDemandList = this.dataDemandArr.filter(item => {
										if (dataDemandRuleList.includes(item.key)) {
											return item;
										}
									});
								}
							}
							resolve();
						}
					});
			});
		},
		contentTypeChange(val) {
			this.contentType = val;
			this.form.resetFields('fansLevel');
			this.fansLevel = null;
			this.form.resetFields('dataDemand');
			this.dataDemand = null;
			this.getCustomState();
			this.seachByContentType(val);
		},
		seachByContentType(val) {
			let awardRuleItemList = [];
			if (val) {
				awardRuleItemList = this.awardRuleItemList.filter(
					item => item.awardType == this.awardType && (item.contentType != null && item.contentType != '' && item.contentType.split(',').includes(val))
				);
			} else {
				awardRuleItemList = this.awardRuleItemList.filter(item => item.awardType == this.awardType && (item.contentType == null || item.contentType == ''));
			}
			// debugger
			//判断有无粉丝
			let fansLevelRuleList = [];
			let showFansLevel = true;
			let requiredFansLevel = true;
			let existFansLevel = false;
			if (['bilibili', 'redbook', 'channels','douyin'].includes(this.platformType2)) {
				//有粉丝层级，先判断显影和是否必填
				if (awardRuleItemList.length > 0) {
					awardRuleItemList.forEach(e => {
						if (e.fansLevel == null || e.fansLevel == '') {
							requiredFansLevel = false;
							showFansLevel = false;
						} else {
							existFansLevel = true;
							Array.prototype.push.apply(fansLevelRuleList,e.fansLevel.split(','));
						}
					});
					if (existFansLevel) {
						showFansLevel = true;
					}
				}
				fansLevelRuleList = [...new Set(fansLevelRuleList)];
				this.showFansLevel = showFansLevel;
				this.requiredFansLevel = requiredFansLevel;
				//需要展示粉丝层级
				if (showFansLevel) {
					this.fansLevelList = this.fansLevelArr.filter(item => {
						if (fansLevelRuleList.includes(item.key)) {
							return item;
						}
					});
				}
			}
			//没有粉丝层级或粉丝层级不显示或粉丝层级不必填，直接查奖励级别
			if (!['bilibili', 'redbook', 'channels','douyin'].includes(this.platformType2) || !showFansLevel || !requiredFansLevel) {
				let dataDemandRuleList = [];
				if (awardRuleItemList.length > 0) {
					awardRuleItemList.forEach(e => {
						if (e.dataDemand != null && e.dataDemand != '') {
							Array.prototype.push.apply(dataDemandRuleList,e.dataDemand.split(','));
						}
					});
				}
				dataDemandRuleList = [... new Set(dataDemandRuleList)];
				this.dataDemandList = this.dataDemandArr.filter(item => {
					if (dataDemandRuleList.includes(item.key)) {
						return item;
					}
				});
			}
		},

		fansLevelChange(val) {
			this.fansLevel = val;
			this.form.resetFields('dataDemand');
			this.dataDemand = null;
			this.getCustomState();
			this.seachByFansLevel(val);
		},
		seachByFansLevel(val) {
			let awardRuleItemList = [];
			if (val) {
				if (this.contentType) {
					awardRuleItemList = this.awardRuleItemList.filter(
						item =>
							item.awardType == this.awardType &&
							(item.contentType != null && item.contentType != '' && item.contentType.split(',').includes(this.contentType)) &&
							(item.fansLevel != null && item.fansLevel != '' && item.fansLevel.split(',').includes(val))
					);
				} else {
					awardRuleItemList = this.awardRuleItemList.filter(
						item =>
							item.awardType == this.awardType &&
							(item.contentType == null || item.contentType == '') &&
							(item.fansLevel != null && item.fansLevel != '' && item.fansLevel.split(',').includes(val))
					);
				}
			} else {
				if (this.contentType) {
					awardRuleItemList = this.awardRuleItemList.filter(
						item =>
							item.awardType == this.awardType &&
							(item.contentType != null && item.contentType != '' && item.contentType.split(',').includes(this.contentType)) &&
							(item.fansLevel == null || item.fansLevel == '')
					);
				} else {
					awardRuleItemList = this.awardRuleItemList.filter(
						item => item.awardType == this.awardType && (item.contentType == null || item.contentType == '') && (item.fansLevel == null || item.fansLevel == '')
					);
				}
			}
			let dataDemandRuleList = [];
			if (awardRuleItemList.length > 0) {
				awardRuleItemList.forEach(e => {
					if (e.dataDemand != null && e.dataDemand != '') {
						Array.prototype.push.apply(dataDemandRuleList,e.dataDemand.split(','));
					}
				});
			}
			dataDemandRuleList = [... new Set(dataDemandRuleList)];

			this.dataDemandList = this.dataDemandArr.filter(item => {
				if (dataDemandRuleList.includes(item.key)) {
					return item;
				}
			});
		},
		dataDemandChange(val) {
			this.dataDemand = val;
			this.getCustomState();
		},
		getCustomState() {
			this.customState = false;
			this.form.resetFields('customAmount');
			this.awardCustomConfig.forEach(e => {
				if (e.platformType == this.platformType && e.awardType == this.awardType && e.contentType == this.contentType && e.dataDemand == this.dataDemand) {
					this.customState = true;
				}
			});
		},
		handleSubmit() {
			this.form.validateFields((err, values) => {
				if (!err) {
					if (this.dataList.length == 0) {
						this.$message.warning('参与人员不能为空');
						return;
					}
					let percentTotal = 0;
					for (let item of this.dataList) {
						if (!item['userId']) {
							this.$message.warning('参与人不能为空');
							return;
						}
						if (!item['position']) {
							this.$message.warning('职位不能为空');
							return;
						}
						if (!item['percent']) {
							this.$message.warning('奖金比例不能为空');
							return;
						}
						percentTotal += item.percent;
					}
					if (percentTotal > 100) {
						this.$message.warning('奖金比例总和不能超过100');
						return;
					}

					let data = {
						...values,
						id: this.id,
						awardRuleId: this.awardRule.id,
						awardParticipantJson: JSON.stringify(this.dataList)
					};
					data.fileIds = [];
					this.fileArr.forEach(function(item) {
						data.fileIds.push(item.id);
					});
					data.fileIds = data.fileIds.join(',');
					this.$post('awardApplyItem/save', { ...data }).then(res => {
						this.$message.success('保存成功');
						this.$emit('success');
					});
				}
			});
		},
		searchUser(value) {
			if (!String(value).trim()) {
				return;
			}
			this.fetch(value, data => (this.userList = data));
		},
		fetch(value, callback) {
			if (timeout) {
				clearTimeout(timeout);
				timeout = null;
			}
			currentValue = value;
			let that = this;
			function fake() {
				that.$get(`user/search`, { realname: value }).then(res => {
					if (currentValue === value) {
						callback(res.data);
					}
				});
			}
			timeout = setTimeout(fake, 300);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/views/OA/qualityContent/weiboContent.vue